import { BaseService } from "./base.service";
export class UniversityRatingsService extends BaseService {
  constructor() {
    super("university-ratings");
  }
}
